import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useUpdateGroupe } from "../../../hooks/useUpdateGroupe";
import { useColors } from "../../../hooks/COLORS/useColors";
import { customSelectStyles } from '../../../utils/reactSelectStyles';

const UpdateGroup = ({ showUpdateGroup, setShowUpdateGroup, groupe }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', couleur: null });

    const { mutateAsync: updateGroupe } = useUpdateGroupe();
    const { data: colorsData } = useColors();

    const options = colorsData?.data?.map(c => ({ value: c.id, label: c.name, hex: c.hex })) || [];

    useEffect(() => {
        if (groupe && options.length > 0) {
            const currentColor = options.find(opt => opt.value === groupe.color?.id);
            setFormData({
                nom: groupe.name || '',
                couleur: currentColor || (groupe.color ? { value: groupe.color.id, label: groupe.color.name, hex: groupe.color.hex } : null)
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupe, colorsData]);

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.nom || !formData.couleur) {
            alert("Veuillez remplir tous les champs");
            return;
        }
        const updatedData = { couleur: parseInt(formData.couleur.value) };
        if (formData.nom !== groupe.name) updatedData.nom = formData.nom;

        setIsSubmitting(true);
        try {
            await updateGroupe({ groupeId: groupe.id, groupeData: updatedData });
            setShowUpdateGroup(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showUpdateGroup} onHide={() => setShowUpdateGroup(false)} size="lg">
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className="modal-title text-group">Modifier le groupe</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label className='text-muted'>Nom du groupe</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nom du groupe"
                                value={formData.nom}
                                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Form.Group className='mb-3' as={Col} controlId="idCouleur">
                            <Form.Label className='text-muted'>Choisissez une couleur</Form.Label>
                            <Select
                                options={options}
                                value={formData.couleur}
                                onChange={(option) => setFormData({ ...formData, couleur: option })}
                                menuPortalTarget={document.body}
                                styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                placeholder="Sélectionnez une couleur"
                                formatOptionLabel={(opt) => (
                                    <div className="d-flex align-items-center gap-2">
                                        <div style={{ width: 16, height: 16, borderRadius: "50%", backgroundColor: opt.hex, border: "1px solid #dee2e6" }} />
                                        {opt.label}
                                    </div>
                                )}
                            />
                        </Form.Group>
                        <Form.Group className='mb-3' as={Col} controlId="previsuCouleur">
                            <Form.Label className='text-muted'>Prévisualisation</Form.Label>
                            <div style={{ height: '38px', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: formData.couleur?.hex || '#e9ecef' }} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowUpdateGroup(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Chargement...' : 'Modifier'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdateGroup;